<!-- 教育局 区级-课程管理 -->
<template>
  <div>
    <div class="index" v-if="!detail.show">
      <!-- <div class="title">
            <div class="span1">
                <span>{{$route.name}}</span>
            </div>
        </div> -->
      <div class="Homeboxtop_nav_tab">
        <span
          v-for="(item, index) in tabList"
          :class="['res-tab', { active: item.name === tabName }]"
          :key="index + 'sh_state'"
          @click="tabClick(item)"
        >
          {{ item.name }}
        </span>
      </div>
      <div>
        <el-form :inline="true" :model="queryParams" label-width="70px">
          <el-form-item label="" label-width="90px">
            <el-input
              v-model="queryParams.cname"
              placeholder="请输入课程名称"
			  clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="" label-width="90px">
            <el-input
              v-model="queryParams.unit"
              placeholder="请输入报审单位名称"
			  clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <!-- <el-select v-model="queryParams.type" clearable placeholder="选择课程分类" class="label">
                        <el-option v-for="item in typeList" :key="item.id+'course_type'" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select> -->
            <coure-type @setCourseType="setCourseType" type="seach"></coure-type>
          </el-form-item>
          <el-form-item label="" style="margin-left: 20px">
            <el-button type="primary" size="small" @click="searchFun()"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>
        <div class="table">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column
              prop="cname"
              label="课程名称"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column align="center" label="课程类型">
              <template slot-scope="scope">
                {{ scope.row.typeName || "" }}
                {{
                  scope.row.subclassName ? "/ " + scope.row.subclassName : ""
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="applyOrgName"
              label="报审单位"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="coverArea"
              label="覆盖区域"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="price"
              label="课程定价"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <p>￥{{ scope.row.price }}</p>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="操作"
              width="200"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="toDetail(scope.row)"
                  >去审核</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  v-if="scope.row.auditState === '2'"
                  @click="toOperate('确定下架课程吗?', '4', scope.row)"
                  >下架</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  v-if="scope.row.auditState === '4'"
                  @click="toOperate('确定上架课程吗?', '2', scope.row)"
                  >上架</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              background
              :current-page="pageNum"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              :total="totalPage"
              layout="total,prev, pager, next,jumper,sizes"
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <Detail
      :info.sync="detail.info"
      v-show="detail.show"
      @to-index="toIndex"
      @to-init="getDataList"
      :type="detail_type"
      :auditState="auditState"
    ></Detail>
  </div>
</template>
<script>
import educationApi from "@/api/education/index.js";
import { getDetail } from "@/api/mechanismApi/curriculum";
import util from "@/utils/util.js";
export default {
  components: {
    Detail: () => import("../courseCheck/detail.vue"),
    coureType: () => import("@/views/components/coureType.vue"),
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      totalPage: 0,
      queryParams: {
        cname: "",
        unit: "",
        typeId: "",
        subclassId: "",
      },
      tableData: [],
      detail: {
        info: {},
        show: false,
      },
      Userlist: JSON.parse(sessionStorage.getItem("Userlist")) || {},
      tabList: [
        { name: "待审核" },
        { name: "审核通过" },
        { name: "审核不通过" },
      ],
      tabName: "待审核",
      auditStateObj: {
        待审核: "1",
        审核通过: "2",
        审核不通过: "3",
      },
      typeList: JSON.parse(sessionStorage.getItem("courseType")) || [],
      detail_type: "handle",
      auditState: "1",
    };
  },
  watch: {
    tabName(n, o) {
      this.pageNum = 1;
      this.getDataList();
    },
  },
  created() {
    this.getDataList();
  },
  methods: {
    tabClick(item) {
      this.tabName = item.name;
    },
    async getDataList() {
      let auditState = this.auditStateObj[this.tabName];
    //   let courseType = this.typeList.filter(
    //       (e) => e.id === this.queryParams.type
    //     ),
    //     type = "";
    //   if (courseType.length) type = courseType[0].id;
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        cname: this.queryParams.cname,
        reportOrgName: this.queryParams.unit,
        typeId: this.queryParams.typeId,
        subclassId: this.queryParams.subclassId, //小的课程类型
        auditState: auditState,
      };
      let res = await educationApi.getEducationCourseManagelist(params);
      if (res.result === "000000") {
        this.tableData = res.data?.list || [];
        this.totalPage = res.data?.total || 0;
      }
    },
    setCourseType(data) {
      this.queryParams.typeId = data.typeId || "";
      this.queryParams.subclassId = data.subclassId || "";
    },
    searchFun() {
      this.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageNum = val;
      this.getDataList();
    },
    async toDetail(item) {
      this.auditState = item.auditState;
      let params = {
        id: item.cid,
      };
      // let paramsData= {
      // cid: item.cid,
      // orgId:sessionStorage.getItem("orgId"),
      // };
      var { result, data } = await getDetail(params);
      // let res= await educationApi.getEducationCourseauditrecord(paramsData);
      if (result == "000000") {
        this.detail.info = data;
        // this.detail.info.orgType = item.orgType;
        // if(res.result==='000000'){
        // 	this.detail.info.operateList=res.data || [];
        // }
        this.detail_type = this.tabName === "待审核" ? "handle" : "manager";
        this.detail.show = true;
      } else {
        this.$message({
          type: "error",
          message: "获取信息失败",
        });
      }
    },
    // 上架/下架课程
    async toOperate(text, type, item) {
      let vm = this;
      util
        .handleCofirm(text, "info")
        .then(async (res) => {
          let params = {
            cid: item.cid,
            auditState: type,
            operateOpinion: "",
            orgId: sessionStorage.getItem("orgId"),
          };
          let { result } = await educationApi.educationCourseOperate(params);
          if (result == "000000") {
            vm.$message({ type: "success", message: "操作成功" });
            vm.getDataList();
          } else {
            vm.$message({ type: "error", message: "操作失败" });
          }
        })
        .catch((err) => {
          console.log("err", err); // cancel
        });
    },
    toIndex() {
      this.detail.show = false;
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .Homeboxtop_nav_tab {
    margin-top: 2%;
  }
  .title {
    height: 60px;
    line-height: 48px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-start;
    .span1 {
      font-family: "PingFang SC Bold";
      font-weight: bold;
      font-size: 20px;
      text-align: left;
      color: #000;
      margin-right: 30px;
    }
  }

  ::v-deep .el-form .el-input__inner {
    width: 160px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
.res-tab {
  padding-bottom: 15px;
}
</style>
